function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Base class for cart adapters.
 */
export var CartAdapterBase = /*#__PURE__*/function () {
  /**
   * Create a CartAdapterBase.
   * @param {Array<any>} addedCartItems - The items added to the cart.
   * @param {Object} cart - The cart object.
   */
  function CartAdapterBase(addedCartItems, cart) {
    _classCallCheck(this, CartAdapterBase);

    this.addedCartItems = addedCartItems;
    this.cart = cart;
  }
  /**
   * Convert the cart data to the AddToCart event model.
   * This method should be overridden by subclasses.
   * @throws {Error} Always throws an error because this method should be implemented in a subclass.
   */


  _createClass(CartAdapterBase, [{
    key: "toAddToCartModel",
    value: function toAddToCartModel() {
      throw new Error('toAddToCartModel not implemented');
    }
    /**
     * Convert the cart data to the Begin Checkout event model.
     * This method should be overridden by subclasses.
     * @throws {Error} Always throws an error because this method should be implemented in a subclass.
     */

  }, {
    key: "toBeginCheckoutModel",
    value: function toBeginCheckoutModel() {
      throw new Error('toBeginCheckoutModel not implemented');
    }
  }, {
    key: "getRebuildCartUrl",
    value: function getRebuildCartUrl() {
      try {
        if (!this.cart) {
          return '';
        }

        var cartAddParams = new URLSearchParams();
        var generator = this.lineItemGenerator(); // eslint-disable-next-line no-unused-vars

        var _iterator = _createForOfIteratorHelper(generator),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            cartAddParams.append('items[][id]', this.lineItemVariantId(item));
            cartAddParams.append('items[][quantity]', item.quantity);
            var sellingPlanId = this.lineItemSellingPlanId(item);

            if (sellingPlanId) {
              cartAddParams.append('items[][selling_plan]', sellingPlanId);
            }

            var lineItemPropertiesGenerator = this.lineItemPropertiesGenerator(item); // eslint-disable-next-line no-unused-vars

            var _iterator3 = _createForOfIteratorHelper(lineItemPropertiesGenerator),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var attribute = _step3.value;
                cartAddParams.append("items[][properties][".concat(attribute.key, "]"), attribute.value);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var cartAttributesGenerator = this.cartAttributesGenerator(this.cart); // eslint-disable-next-line no-unused-vars

        var _iterator2 = _createForOfIteratorHelper(cartAttributesGenerator),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _attribute = _step2.value;
            cartAddParams.append("attributes[".concat(_attribute.key, "]"), _attribute.value);
          } // final redirect sends user to the checkout page

        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        cartAddParams.append('return_to', '/checkout');
        var cartClearParams = new URLSearchParams();
        cartClearParams.append('return_to', "/cart/add?".concat(cartAddParams.toString()));
        return "".concat(window.location.origin, "/cart/clear?").concat(cartClearParams.toString());
      } catch (err) {
        console.error('Error building return-to-cart URL', err);
        return '';
      }
    }
  }, {
    key: "lineItemGenerator",
    value: function lineItemGenerator() {
      throw new Error('lineItemGenerator not implemented');
    }
  }, {
    key: "lineItemVariantId",
    value: function lineItemVariantId(item) {
      throw new Error("lineItemVariantId not implemented: ".concat(JSON.stringify(item)));
    }
  }, {
    key: "lineItemSellingPlanId",
    value: function lineItemSellingPlanId(item) {
      throw new Error("lineItemSelllingPlanId not implemented: ".concat(JSON.stringify(item)));
    }
  }, {
    key: "lineItemPropertiesGenerator",
    value: function lineItemPropertiesGenerator(item) {
      throw new Error("lineItemPropertiesGenerator not implemented: ".concat(JSON.stringify(item)));
    }
  }, {
    key: "cartAttributesGenerator",
    value: function cartAttributesGenerator(cart) {
      throw new Error("attributesGenerator not implemented: ".concat(JSON.stringify(cart)));
    }
  }]);

  return CartAdapterBase;
}();